// extracted by mini-css-extract-plugin
module.exports = {"root":"RechartsComparisonChart_root__35q1v","yUnitLabel":"RechartsComparisonChart_yUnitLabel__3WG53"};